import {EditPermissions} from "../../../../shared/models";


export interface EditTypes {
    editMenuTextOnly: boolean,
    editFlows: boolean,
}

export const getEditTypes = (editPermissions: EditPermissions): EditTypes => {
    const {canEditFlows, canEditMenuTextOnly, canEdit} = editPermissions
    const editMenuTextOnly = (canEdit && (canEditFlows || canEditMenuTextOnly))
    const editFlows = (canEdit && (canEditFlows))
    return {
        editMenuTextOnly,
        editFlows
    }
}